<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input
        v-model="searchDevice"
        clearable
        @clear="clearSearch"
        :placeholder="$t('business.placeholder.keyword')"
      >
        <!-- <el-button slot="append"
                   icon="el-icon-search"
                   @click="searchBtnClick"></el-button> -->
      </el-input>
    </div>
    <div class="filter_actions" v-show="cameraData.length > 0 && isCollection">
      <label @click="getChosenCount" class="font-default-color"
        >{{ $t("video.label.selected") }}{{ cameraData.length
        }}{{ $t("video.label.a") }}</label
      >
      <div>
        <span @click="handleCollection(cameraData)" style="margin-right: 5px">{{
          $t("video.label.addFavorite")
        }}</span>
      </div>
    </div>
    <div class="area-container">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          ref="appAreaTree"
          v-if="showTree"
          :data="dataList"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="checkDeviceID"
          :filter-node-method="filterNode"
          @check-change="checkChange"
          @node-click="getCheckNode"
        >
          <div
            unselectable="on"
            onselectstart="return false;"
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ node, data }"
            :class="{
              'out-line':
                parseInt(data.status) !== 1 && data.nodeType === 'device',
            }"
            @dblclick="deviceChoose(data)"
          >
            <div class="node-cover"></div>
            <!-- <i v-show="data.nodeType === 'area'" :class="careraIcon(data)"></i> -->
            <i
              v-show="data.nodeType === 'area'"
              :class="[areaIcon(data), 'area-node-icon']"
            ></i>
            <i
              v-show="data.nodeType === 'device'"
              class="iconfont-lunan icon-lunan-shexiangtou"
            ></i>
            <!-- <i v-show="data.nodeType === 'area'" :class="[$config.fontFamily, 'ioc-Build', 'area-node-icon']"></i> -->
            <span>{{ data.name }}</span>
            <span v-show="data.nodeType !== 'device' && showPercentage">{{
              getInlinePercentage(data)
            }}</span>
            <i
              v-show="data.nodeType === 'device'"
              :class="[
                'icon',
                'iconfont-lunan',
                careraIcon(data),
                'camera-type-icon',
              ]"
            ></i>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Cache } from "$utils";
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false,
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    isCollection: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchDevice(val) {
      this.$refs.appAreaTree.filter(val);
    },
  },
  data() {
    return {
      dataList: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      showTree: true,
      pageActive: true,
      searchDevice: "",
      cameraData: [],
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: [],
      checkDevice: [],
      checkDeviceID: [],
    };
  },
  beforeDestroy() {
    this.pageActive = false;
    this.dataList = [];
  },
  mounted() {
    this.queryDevice();
  },
  methods: {
    //重置
    clearSearch() {
      this.searchDevice = "";
      this.filterText();
    },
    // 检索树
    filterText() {
      if (!this.searchDevice) {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
        this.queryDevice();
        return;
      }
      this.$refs.appAreaTree.filter(this.searchDevice.trim());
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
    careraIcon(data) {
      switch (data.ability) {
        case "0":
          return "";
        case "1":
          return "icon-lunan-renyuanbukong";
        case "2":
          return "icon-lunan-cheliangbukong";
        default:
          return "";
      }
    },
    areaIcon(data) {
      const account = Cache.get("CACHE_USER_INFO");
      if (account.parkInfo.areaDevGroupCode === data.id) {
        return this.$config.fontFamily + " ioc-Build";
      } else {
        return "el-icon-office-building";
      }
    },
    // 在线率
    getInlinePercentage(data) {
      data.inlineCount = data.inlineCount || 0;
      data.totalCount = data.totalCount || 0;
      let percentage = parseInt((data.inlineCount / data.totalCount) * 100);
      return `(${data.inlineCount}/${data.totalCount};${percentage || 0}%)`;
    },
    // 查询树
    queryDevice() {
      this.$fetch("/vas/controltask/queryControlTaskCamera.json", {
        controlType: 2,
        controlFlag: "1",
      }).then((response) => {
        if (!this.pageActive) {
          console.log("页面已销毁，停止数据处理");
          return;
        }
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          const account = Cache.get("CACHE_USER_INFO");
          if (response.returnObj && response.returnObj.length) {
            response.returnObj.forEach((item) => {
              item.nodeType = "device";
              item.children = [];
              item.name = item.deviceName;
              item.id = item.thirdDeviceId;
              item.label = item.deviceName;
            });
          }
          // if (this.searchDevice != '') {
          //   if (response.returnObj && response.returnObj.length) {
          //     this.dataList = response.returnObj
          //     this.checkChildNodes(this.searchDevice, response.returnObj)
          //   } else {
          //     this.expandedKeys = [account.parkInfo.areaDevGroupCode]
          //     this.dataList = []
          //   }
          // } else {

          // }

          this.expandedKeys = [account.parkInfo.areaDevGroupCode];
          let result = response.returnObj;
          this.dataList = result;
          result = null;
          this.$emit("sendData", this.dataList);
        }
      });
    },
    // 通过thirdDeviceId获取对应的ID
    getTreeCheckedArr(list, id) {
      const self = this;
      let cameraId = "";
      list.forEach((item, index) => {
        if (item.thirdDeviceId == id) {
          cameraId = item.id;
          this.checkDevice.push(item);
          return cameraId;
        } else {
          if (item.children && item.children.length > 0) {
            let res = self.getTreeCheckedArr(item.children, id);
            if (res) {
              cameraId = res;
              return cameraId;
            }
          }
        }
      });
      if (cameraId !== "") {
        this.checkDeviceID.push(cameraId);
        this.expandedKeys.push(cameraId);
        this.$emit("getCameraData", this.checkDevice);
      }
    },
    deviceDataPro(devices, parentName) {
      let list = {};
      if (devices && devices.length) {
        devices.forEach((item) => {
          if (item.nodeType === "device") {
            list[item.id] = {
              areaName: parentName,
              ...item,
            };
            // console.log('设备list', list)
          } else if (item.nodeType === "area") {
            list = Object.assign(
              list,
              this.deviceDataPro(item.children, item.name)
            );
            // console.log('区域list', list)
          }
        });
      }
      return list;
    },
    handleCollection(data) {
      this.$emit("handleCollection", data);
    },
    searchBtnClick() {
      if (this.searchDevice == "" && !this.searchDeviceChange) return;
      this.queryDevice();
    },
    getChosenCount() {
      return this.cameraData.length;
    },
    resetSelect() {
      this.$refs.appAreaTree.setCheckedKeys([]);
      this.cameraData = [];
      this.checkDevice = [];
      this.expandedKeys = [];
      this.checkDeviceID = [];
    },
    // 双击
    deviceChoose(nodeData) {
      if (nodeData.nodeType != "area") {
        if (nodeData.status != 1) {
          this.$message.warning(this.$t("business.message.offline"));
          return;
        }
        this.$emit("deviceChoose", nodeData);
      }
    },
    // 单击
    getCheckNode(nodeData) {
      if (nodeData.nodeType !== "area") {
        this.$emit("deviceClick", nodeData);
      } else {
        this.$emit("areaClick", nodeData);
      }
    },
    // 多选
    checkChange(node, status) {
      // node 当前被点击的节点   checkData树目前的选中状态对象
      console.log("checkedNodes------------", this.checkDeviceID, node, status);
      if (node.nodeType != "area") {
        if (this.checkDeviceID.indexOf(node.id) === -1) {
          this.checkDevice.push(node);
          this.checkDeviceID.push(node.id);
        } else {
          this.checkDevice.splice(this.checkDeviceID.indexOf(node.id), 1);
          this.checkDeviceID.splice(this.checkDeviceID.indexOf(node.id), 1);
        }
      } else {
        this.$message.warning("请勾选摄像机");
      }
      if (this.checkDevice.length > 2) {
        this.checkDevice = this.checkDevice.slice(0, 2);
        this.checkDeviceID = this.checkDeviceID.slice(0, 2);
        this.$message.warning("最多选择两个摄像机");
      }
      this.$refs.appAreaTree.setCheckedKeys(this.checkDeviceID);
      this.cameraData = this.checkDevice;
      this.$emit("getCameraData", this.checkDevice);
    },
    // 判断是否含有子节点
    checkChildNodes(str, arr) {
      for (let item of arr) {
        if (item.name.search(str.trim()) != -1) {
          this.expandedKeys.push(item.id);
        }
        if (item.children.length > 0) {
          this.checkChildNodes(str, item.children);
        }
      }
    },
    resetScroll() {
      setTimeout(() => {
        this.$refs.scrollBar.update();
      }, 500);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/theme";
@import "~@src/common/assets/style/mixin";
.app-area-list {
  width: 290px;
  height: 100%;
  overflow-y: hidden;
  .el-scrollbar__wrap {
    @include set_theme_color(background-color, top-menu-bg-color);
  }
  // .el-tree-node__children {
  //   display: inline-flex !important;
  //   flex-direction: column !important;
  // }
  .node {
    position: relative;
    display: inline-flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &.out-line {
      color: #757373;
      .icon {
        color: #757373;
      }
    }
    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    height: calc(100% - 32px);
    .area-node-icon {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 100%;
    z-index: 1;
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
    }
  }
}
</style>
